import React, { Component } from 'react';
import { FormControl, FormGroup } from 'react-bootstrap';

module.exports = {
    CheckBox: class Checkbox extends Component {
        constructor(props) {
            super(props);

            var isChecked = this.isChecked(this.props.isChecked);

            this.state = {
                isChecked: isChecked
            }
        }

        isChecked(isCheckedObj) {
            var isChecked;

            if (typeof (isCheckedObj) === "function") {
                isChecked = isCheckedObj(this.props.id);
            } else {
                if (isCheckedObj == undefined || isCheckedObj == "") {
                    isChecked = false;
                }
                else
                    isChecked = true;
            }

            return isChecked;
        }
        /*
                componentWillReceiveProps(nextProps)
                {
                    var isChecked = this.isChecked(nextProps.isChecked);
                    if (isChecked != this.state.isChecked) {
                        this.setState({isChecked: isChecked});
                    }
                }*/

        toggleCheckboxChange() {
            var isChecked = this.state.isChecked;

            this.setState({
                isChecked: !isChecked
            });

            if (this.props.onChange) {
                this
                    .props
                    .onChange(this.props.id, !isChecked);
            }
        }

        setChecked(isChecked) {
            this.setState({
                isChecked: isChecked
            });
        }

        unCheck() {
            this.setState({ isChecked: false });
        }

        render() {
            const { isChecked } = this.state;

            return (
                <div className='whiteCheckBox'>
                    <input
                        type="checkbox"
                        id={this.props.id}
                        name={this.props.id}
                        onChange={this
                            .toggleCheckboxChange
                            .bind(this)}
                        checked={isChecked} />
                    <label htmlFor={this.props.id}>
                        <span></span>{this.props.children}</label>
                </div>
            )
        }
    },
    FControl: React.createClass({
        render: function () {
            return (<FormControl
                type={this.props.type}
                placeholder={this.props.placeholder}
                name={this.props.id}
                id={this.props.id} autoComplete="off" />)
        }
    }),
    ApplyAndReset: React.createClass({
        render: function () {
            return (
                <div>
                    <button className='apply-filters' onClick={this.props.Search}>APPLY FILTERS</button>
                    <label
                        className='reset-filters'
                        onClick={this
                            .props
                            .ApplyReset
                            .bind(this)}>
                        <div className='reset-icon'>&nbsp;</div>
                        Reset selections
                    </label>
                </div>
            )
        }
    })
};


// WEBPACK FOOTER //
// ./modules/common/forms.jsx